<template>
  <div class="col-12 mb-1 m-0 p-0">
    <b-row>
      <b-form-group
        class="required-control"
        :class="stackWarehouseUnderDate ? 'col-12' : 'col-md-6'"
        :disabled="!editable"
      >
        <label class="font-weight-bold">{{ stockSlipDate.label }}:</label>
        <date-picker
          :placeholder="stockSlipDate.placeholder"
          class="mb-2 mt-2 form-control form-control-sm"
          :config="dpConfigs.date"
          v-model="stockSlip.stockSlipDate"
          :disabled="!editable"
          aria-describedby="input-date-feedback"
        ></date-picker>

        <b-form-invalid-feedback v-if="!stockSlip.validateState">
          {{ stockSlipDate.helpText }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-col
        v-if="!hideWarehouse"
        cols="12"
        :md="stackWarehouseUnderDate ? 12 : 6"
        :lg="stackWarehouseUnderDate ? 12 : 6"
      >
        <b-form-group class="required-control">
          <label class="font-weight-bold">Kho nhập:</label>
          <Autosuggest
            class="border-radius-none mt-2"
            :model="stockSlip.sourceWarehouseName"
            :suggestions="stores"
            placeholder="Kho"
            :limit="200"
            @select="onSelectedSourceWarehouse"
            @change="onInputChangeSourceWarehouse"
            suggestionName="name"
            :disabled="!editable"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12">
        <b-form-group>
          <label>Ghi chú:</label>
          <b-form-textarea
            size="sm"
            v-model="stockSlip.notes"
            :placeholder="'Thêm nội dung ghi chú...'"
            :rows="6"
            :max-rows="6"
            :disabled="!editable"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { validationMixin } from 'vuelidate';
import required from 'vuelidate/lib/validators/required';

export default {
  mixins: [validationMixin],
  props: {
    stockSlip: { type: Object, required: true },
    stores: { type: Array, default: () => [] },
    editable: { type: Boolean, default: true },
    /** true: Ngày nhập kho và Kho nhập mỗi field một dòng (full width). */
    stackWarehouseUnderDate: { type: Boolean, default: false },
    /** true: không hiển thị kho (vd. batch ProductStock theo sản phẩm — không bắt buộc storeId). */
    hideWarehouse: { type: Boolean, default: false },
  },
  created() {},
  data() {
    return {
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      stockSlipDate: {
        label: 'Ngày nhập kho',
        placeholder: 'Chọn ngày nhập kho',
        helpText: 'Vui lòng chọn ngày nhập kho',
      },
    };
  },
  components: { Autosuggest },
  validations: {
    form: {
      stockSlipDate: { required },
    },
  },
  methods: {
    onSelectedSourceWarehouse(data) {
      this.$emit('onSelectedSourceWarehouse', data);
    },
    onInputChangeSourceWarehouse(data) {
      this.$emit('onInputChangeSourceWarehouse', data);
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="css" scoped>
.center-label label {
  margin-bottom: 0px;
}

.form-group label {
  font-weight: 500;
}
</style>
